export default __webpack_public_path__ + "static/media/network-graph-2-rMAX.6e048a69.jpg";